import React from 'react';
import { Container } from "react-bootstrap";
import { useData } from '../../context/DataContext';
import { MaterialReactTable } from 'material-react-table';
import Loading from '../Loading/Loading';

function Orders() {
    const { orderData, loading, error } = useData();

    if (loading) return <Loading />;
    if (error) return <div style={{ padding: 24, color: 'red' }}>Error: {error}</div>;
    if (!orderData) return <div style={{ padding: 24 }}>No order data available.</div>;

    const columns = [
        { accessorKey: 'id', header: 'Order ID', size: 80 },
        { accessorKey: 'id', id: 'product', header: 'Product' },
        { accessorKey: 'id', id: 'qty', header: 'Quantity' },
        { accessorKey: 'id', id: 'amount', header: 'Amount' },
        { accessorKey: 'id', id: 'date', header: 'Order Date' },
    ];

    return (
        <Container fluid className="px-0">
            <div className="page-header">
                <div>
                    <h1 className="page-title">Orders</h1>
                    <p className="page-subtitle">{orderData.length} orders total</p>
                </div>
            </div>

            <div className="table-container">
                <MaterialReactTable columns={columns} data={orderData} enableSorting enablePagination />
            </div>
        </Container>
    );
}

export default Orders;
